.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  padding: var(--space-l);

  background-color: var(--surface-sunken);

  border-radius: var(--radius-m);
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  gap: var(--space-m);
}

.headline {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
}

.title {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  font-size: var(--size-500);
}

/* The catalog's count pill, sized against the heading rather than the tree row. */
.count {
  display: inline-flex;
  align-items: center;

  padding: 0 var(--space-xs);
  min-width: 1.75rem;
  height: 1.5rem;

  justify-content: center;

  font-size: var(--size-200);
  font-weight: var(--weight-medium);
  font-variant-numeric: tabular-nums;
  line-height: 1;

  color: var(--text-muted);
  background-color: #ffffff14;

  border-radius: var(--radius-pill);
}

.description {
  font-size: var(--size-200);

  color: var(--text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-xs);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-m);
}

/* The folding heading. Mirrors the twisty on the catalog tree, at heading size. */
.disclosure {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2xs);

  padding: 0;

  font: inherit;
  color: inherit;
  text-align: start;

  background-color: transparent;

  border: none;

  cursor: pointer;
}

.disclosure:hover {
  color: var(--accent);
}

.disclosure svg {
  color: var(--text-faint);
}

.disclosure:hover svg {
  color: var(--accent);
}
